import { FormLang } from './form/form.lang';
import { ForgetPasswordLang } from './forgetPassword/forgetpassword.lang';
import { ConnectServerLang } from './connectServer/connect.lang';

export const SigninLang = {
    form: FormLang,
    forgetPass: ForgetPasswordLang,
    connectServer: ConnectServerLang,
    text: 'آدرس سرور خود را وارد کنید',
    serverAdd: 'آدرس سرور',
    submit: 'ثبت',
    cancel: 'انصراف',
};
